module.exports = __webpack_public_path__ + "static/media/victory.d5a884f2.wav";